import { ServicingParams } from 'app/models/servicing-params'

export const GET_SERVICING = 'servicing/GET_SERVICING'
export const SERVICING_WINDOW_REQUESTED = 'servicing/SERVICING_WINDOW_REQUESTED'
export const START_LOADING_SERVICING = 'servicing/START_LOADING_SERVICING'
export const STOP_LOADING_SERVICING = 'servicing/STOP_LOADING_SERVICING'
export const INVALIDATE_SERVICING = 'servicing/INVALIDATE_SERVICING'
export const SERVICING_LOAD_FAILED = 'servicing/SERVICING_LOAD_FAILED'
export const SET_SERVICING_FEE_AMOUNTS = 'servicing/SET_SERVICING_FEE_AMOUNTS'
export const SERVICING_FEE_AMOUNTS_FAILED =
  'servicing/SERVICING_FEE_AMOUNTS_FAILED'

/** Query string of GET /api/servicing/events. The tabs filter locally, so no bucket. */
export interface ServicingFeedQuery {
  /** Inclusive upper bound of the event-date window, YYYY-MM-DD; default business date + 10 days. */
  to?: string
}

export interface ServicingSourceError {
  source: string
  message: string
}

/** The window the feed was built for, as the backend echoes it. */
export interface ServicingFeedWindow {
  to: string
  horizonDays: number
  /** 'business-date' when a BusinessDate contract was visible, 'today' when the server fell back to its date. */
  source: 'business-date' | 'today'
}

/** GET /api/servicing/events */
export interface ServicingFeedResponse {
  /** The business date the feed was built for, YYYY-MM-DD. */
  asOf: string
  window: ServicingFeedWindow
  events: ServicingParams[]
  errors: ServicingSourceError[]
}

/** GET /api/servicing/fee-amounts: the priced fees by id; a fee not due is absent. */
export interface ServicingFeeAmountsResponse {
  asOf: string
  to: string
  /** By fee id, every fee priced above 0; a fee priced at 0 is not due and absent. */
  amounts: Record<string, number>
  /** Fees the ledger could not price: amount unknown, NOT "not due". */
  unpriced: string[]
  errors: ServicingSourceError[]
}
